export enum PaymentReviewStatus {
  Pending = 'pending',
  ManuallyApproved = 'manually_approved',
  AutoApproved = 'auto_approved',
  Rejected = 'rejected',
}

export enum PaymentReviewReason {
  PossibleDuplicate = 'possible_duplicate',
  HighAmount = 'high_amount',
}

export enum PartnerDriverPaymentStatus {
  RequiresFunding = 'requires_funding',
  WaitingForFunding = 'waiting_for_funding',
  Paid = 'paid',
  NotPaid = 'not_paid',
  Pending = 'pending',
  Failed = 'failed',
  Returned = 'returned',
  RolledUpToMaster = 'rolled_up_to_master',
  Voided = 'voided',
}

export enum TransactionReconciliationStatus {
  MarkedForReview = 'marked_for_review',
  Authorized = 'authorized',
  MissingAssignedInvoice = 'missing_assigned_invoice',
  RefundInitiated = 'refund_initiated',
}

export enum TransactionType {
  Credit = 'credit',
  Debit = 'debit',
}

export enum TransactionPaymentType {
  Ach = 'ach',
  Wire = 'wire',
  Card = 'card',
  Rtp = 'rtp',
}

export enum TransactionReferenceType {
  FeeWithdrawal = 'fee_withdrawal',
  InvoicePayment = 'invoice_payment',
  ContractorPayment = 'contractor_payment',
  Refund = 'refund',
}

export enum RefundStatus {
  Created = 'created',
  InProgress = 'in_progress',
  Paid = 'paid',
  Failed = 'failed',
}

export enum RefundReferenceType {
  Invoice = 'invoice',
  ContractorPayment = 'contractor_payment',
  ContractorEarning = 'contractor_earning',
  IncomingTransaction = 'incoming_transaction',
}

/** Wire values are snake case — Retool's `CustomerAccount` casing is a 400. */
export enum RefundDestinationType {
  GigsafeAccount = 'gigsafe_account',
  CustomerAccount = 'customer_account',
}

/** The rails a refund can go out on (para-node `PayoutMethodType` subset). Backend default: ACH. */
export enum RefundPaymentRail {
  Ach = 'ach',
  Rtp = 'rtp',
}

export enum FeeWithdrawalStatus {
  Created = 'created',
  InProgress = 'in_progress',
  Paid = 'paid',
  Failed = 'failed',
}

/** `all` is a withdrawal that carries both standard and insurance fees, not a "no filter". */
export enum FeeWithdrawalType {
  All = 'all',
  Standard = 'standard',
  Insurance = 'insurance',
}

export enum BankOnboardingStatus {
  OnboardingStarted = 'ONBOARDING_STARTED',
  DataValidationInProcess = 'DATAVALIDATION_IN_PROCESS',
  CustomerRecordInProcess = 'CUSTOMERRECORD_IN_PROCESS',
  VirtualAccountSetupInProcess = 'VIRTUALACCOUNT_SETUP_IN_PROCESS',
  OnboardingProcessCompleted = 'ONBOARDING_PROCESS_COMPLETED',
  ApplicationClosed = 'APPLICATION_CLOSED',
}

export enum LegalStructure {
  Corp = 'CORP',
  Llc = 'LLC',
  Part = 'PART',
  Sp = 'SP',
  Nplao = 'NPLAO',
  Org = 'ORG',
  Trust = 'TRUST',
  Estate = 'ESTATE',
  Gov = 'GOV',
  Nonp = 'NONP',
  Muni = 'MUNI',
  Llcso = 'LLCSO',
}

export enum EntityIdentificationType {
  Ein = 'EIN',
  Tin = 'TIN',
}

export enum PersonIdentificationType {
  Ssn = 'SSN',
  Itin = 'ITIN',
}

/** Lowercase on the wire, unlike every other onboarding enum. */
export enum BankOnboardingAddressType {
  Residential = 'residential',
  Business = 'business',
}

export enum EarningOrderStatus {
  Created = 'created',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
  Voided = 'voided',
  FailedToCreate = 'failed_to_create',
  Returned = 'returned',
}

export enum UsBankDestinationType {
  BankAccount = 'bank_account',
  Card = 'card',
}

export enum AchType {
  Standard = 'standard',
  SameDay = 'same_day',
}

/** `enabled: true` on either flag means the killswitch is ACTIVE — processing is STOPPED. */
export enum KillswitchFeature {
  PaymentProcessing = 'UsBankPaymentProcessingKillswitch',
  Webhooks = 'UsBankWebhooksKillswitch',
}

export enum CapturedEventSource {
  PaymentProcessing = 'payment_processing',
  Refund = 'refund',
  AchWebhook = 'ach_webhook',
  CardWebhook = 'card_webhook',
  InstantPaymentWebhook = 'instant_payment_webhook',
}

export enum CapturedEventStatus {
  Pending = 'pending',
  Replayed = 'replayed',
  Discarded = 'discarded',
  ReplayFailed = 'replay_failed',
}
